import { useEffect, useRef, useState, Fragment } from "react";
// material

import NextLink from "next/link";
import Image from "next/image";

import { alpha } from '@mui/material';
import { Box, MenuItem, FormControl, Grid, Select, Avatar, Stack, Typography, Link, Button } from '@mui/material';
// components
import MenuPopover from "./MenuPopover";
import Scrollbar from "./Scrollbar";
import { useJnzAuth } from "@root/jnzAuth";
import { MenuIcon } from "./assets";

const base_btn_component = "btn_service_switcher";
const defaultLogo = 'https://jnz-media-zeus.s3.ap-southeast-1.amazonaws.com/jenosize/icon_jnz_mkt_cloud.png';

// ----------------------------------------------------------------------

export default function ServicePopover(props) {

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [company, setCompany] = useState(null);
  const [companyList, setCompanyList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const { isLogin } = useJnzAuth();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelectCompany = (companyUUID) => {
    window["jnzauth"].setCompany(companyUUID);
    window.location.reload();
  };

  const handleClickService = (serviceUrl, companyUuid, serviceUuid) => {
    if (!serviceUrl) return;
    window["jnzauth"].goToService(serviceUrl, companyUuid, serviceUuid);
  };

  const getSelCompanyLogo = () => {
    const index = companyList.findIndex((val) => val.company_uuid === company);
    if (index === -1) return null;

    return companyList[index]?.company_media?.logo || null;
  };

  const companyLogo = getSelCompanyLogo();

  useEffect(() => {

    if (isLogin) {

      window["jnzauth"].getCompanyList().then((result) => {
        if (result?.length > 0) {

          const selCompany = window["jnzauth"].getCompany();
          const isMatch = result.findIndex((val) => val.company_uuid === selCompany) > -1;
          const nextCompany = isMatch ? selCompany : result[0].company_uuid;

          setCompanyList(result);

          if (!selCompany || !isMatch) {
            window["jnzauth"].setCompany(result[0].company_uuid);
            window.location.reload();
          }

          setCompany(nextCompany);

          window["jnzauth"].getServiceList(nextCompany).then((services) => {
            setServiceList(Array.isArray(services) ? services : []);
          });
        }
      });
    }

    return () => { };
  }, [isLogin]);

  return (
    <Fragment>
      <Button
        rel="gtmbtn"
        id={`${base_btn_component}_open`}
        variant="outlined"
        color="inherit"
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: { xs: 0.5, sm: 1 },
          height: { xs: 40, sm: 48 },
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
          }),
        }}
      >
        <Box
          position="relative"
          sx={{ width: { xs: 30, sm: 70 }, height: 35, borderRadius: "4px", overflow: "hidden" }}
          mr={1}
        >
          {companyLogo && <Image priority={true} src={companyLogo} layout="fill" />}
        </Box>
        <MenuIcon sx={{ width: { xs: 18, sm: 24 }, height: { xs: 18, sm: 24 } }} />
      </Button>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: 415 }}>
        <Scrollbar sx={{ height: 400 }}>
          {!companyList.length ? (
            <Box pt={6} textAlign="center">
              <Typography variant="body2"> {"Company doesn't exist"} </Typography>
              <NextLink href="/" passHref>
                <Link color="info.main" variant="caption" id={`${base_btn_component}_company_create`}>
                  {" "}
                  {"Create company"}{" "}
                </Link>
              </NextLink>
            </Box>
          ) : (
            <Stack spacing={1} sx={{ p: 3 }}>
              <FormControl size="small" variant="outlined" fullWidth>
                <Select
                  rel="gtmbtn"
                  id={`${base_btn_component}_company_list`}
                  displayEmpty
                  value={company}
                  onChange={(e) => {
                    handleSelectCompany(e.target.value);
                  }}
                >
                  {companyList.map((val) => (
                    <MenuItem
                      key={val?.company_uuid}
                      value={val?.company_uuid}
                      id={`${base_btn_component}_company_${val?.company_uuid}`}
                    >
                      <Box display="flex" alignItems="center">
                        <Box
                          position="relative"
                          flex="0 0 70px"
                          sx={{ width: 70, height: 35, borderRadius: "4px", overflow: "hidden" }}
                        >
                          {val?.company_media?.logo && (
                            <Image priority={true} src={val?.company_media?.logo} layout="fill" />
                          )}
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column", ml: 1, overflow: "hidden" }}>
                          <Typography variant="body1" noWrap>
                            {" "}
                            {val?.company_name}{" "}
                          </Typography>
                          <Typography variant="body2" sx={{ color: "text.secondary" }}>
                            {" "}
                            {val?.admin_role_name}{" "}
                          </Typography>
                        </Box>
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Grid container>
                {serviceList.map((service) => (
                  <Grid item xs={4} sx={{ justifyContent: "center" }} key={service.service_uuid}>
                    <Button
                      rel="gtmbtn"
                      id={`${base_btn_component}_service_${service.service_uuid}`}
                      fullWidth
                      onClick={() => handleClickService(service.service_url, company, service.service_uuid)}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          hieght: 75,
                        }}
                      >
                        <Avatar alt={service?.service_name} src={service?.service_icon_image_url || defaultLogo} />
                        <Typography variant="body2" sx={{ color: "text.primary" }}>
                          {service?.service_name || ''}
                        </Typography>
                      </Box>
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </Stack>
          )}
        </Scrollbar>
      </MenuPopover>
    </Fragment>
  );
}
